'use strict';

var carousel = require('../carousel'),
    productTile = require('./../product-tile'),
    SLOT_SELECTOR = '[id^="cq_recomm_slot"]',
    READY_ATTR = 'data-recomm-ready';

function dispatchLoaded(slot) {
  var event;
  //IE has CustomEvent, but doesn't support constructor
  try {
    event = new CustomEvent('recommendations.loaded', {detail: {container: slot}});
  } catch (e) {
    event = document.createEvent('CustomEvent');
    event.initCustomEvent('recommendations.loaded', false, false, {container: slot});
  }
  document.dispatchEvent(event);
}

// Inits a slot once its tiles are in the DOM; returns false while the slot is still empty
function initSlot(slot) {
  if (slot.getAttribute(READY_ATTR)) {
    return true;
  }
  if (!slot.querySelector('.grid-tile')) {
    return false;
  }
  slot.setAttribute(READY_ATTR, 'true');
  carousel.initRecommCarousels($(slot));
  productTile.init();
  dispatchLoaded(slot);
  return true;
}

// Einstein injects slot content asynchronously (after the CQuotient call), so it can land before or after
// DOM ready / window load. Instead of a fixed delay, init filled slots now and watch the empty ones.
function initRecomm() {
  var pending = [],
      observer;

  $(SLOT_SELECTOR).each(function() {
    if (!initSlot(this)) {
      pending.push(this);
    }
  });

  if (!pending.length || !window.MutationObserver) {
    return;
  }

  observer = new MutationObserver(function() {
    pending = $.grep(pending, function(slot) {
      return !initSlot(slot);
    });
    if (!pending.length) {
      observer.disconnect();
    }
  });

  $.each(pending, function(i, slot) {
    observer.observe(slot, {childList: true, subtree: true});
  });
}

module.exports = {
   init: function() {
     initRecomm();
   }
};
